import {ActionMenu, ActionList} from '@primer/react'
import {usePulsePeriod} from '../contexts/PulsePeriodContext'

export function PeriodMenu() {
  const {selectedPeriod, onPeriodChange} = usePulsePeriod()

  return (
    <ActionMenu>
      <ActionMenu.Button>
        <div className="d-flex gap-1">
          <span className="color-fg-muted">Period:</span>
          <span data-menu-button>{selectedPeriod}</span>
        </div>
      </ActionMenu.Button>
      <ActionMenu.Overlay>
        <ActionList selectionVariant="single">
          <ActionList.Item selected={selectedPeriod === '24 hours'} onSelect={() => onPeriodChange('24 hours')}>
            24 hours
          </ActionList.Item>
          <ActionList.Item selected={selectedPeriod === '3 days'} onSelect={() => onPeriodChange('3 days')}>
            3 days
          </ActionList.Item>
          <ActionList.Item selected={selectedPeriod === '1 week'} onSelect={() => onPeriodChange('1 week')}>
            1 week
          </ActionList.Item>
          <ActionList.Item selected={selectedPeriod === '1 month'} onSelect={() => onPeriodChange('1 month')}>
            1 month
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
